import { Package } from 'lucide-react'

import { getProductImageURL } from '@/lib/product-image'

/**
 * Bố cục 1 option lô trong Combobox chọn lô (dùng chung mọi loại lô).
 *
 * - Dòng 1: `title` — mô tả "là gì" (hộ dân / loại / tên vật tư / tên SP), đậm, truncate.
 * - Dòng 2: `code` (mono) + các `chips` ngắn (vị trí…) nối bằng `·` ở trái;
 *   `qty` (KL khả dụng, đậm) canh phải.
 * - Dòng 3 (tuỳ chọn): `thirdLine` — vd "NSX 01/2026 · HSD 12/2026" cho lô thành phẩm.
 * - `imageSlot=true`: chừa ô ảnh 40×40 bên trái (lô thành phẩm); `imageUrl` rỗng → icon.
 */
export interface LotOptionRowProps {
    title: string
    code: string
    qty: string
    chips?: Array<string | null | undefined>
    thirdLine?: string
    imageSlot?: boolean
    imageUrl?: string | null
}

export function LotOptionRow({
    title,
    code,
    qty,
    chips,
    thirdLine,
    imageSlot,
    imageUrl,
}: LotOptionRowProps) {
    const metaLeft = [code, ...(chips ?? [])].filter(Boolean).join(' · ')
    return (
        <div className="flex w-full items-center gap-3">
            {imageSlot &&
                (imageUrl ? (
                    <img
                        src={getProductImageURL(imageUrl)}
                        alt={title}
                        className="size-10 flex-shrink-0 rounded-md object-cover"
                    />
                ) : (
                    <div className="flex size-10 flex-shrink-0 items-center justify-center rounded-md bg-muted">
                        <Package className="size-5 text-muted-foreground" />
                    </div>
                ))}
            <div className="min-w-0 flex-1">
                <div className="truncate text-sm font-medium">{title}</div>
                <div className="flex items-baseline gap-2">
                    <div className="min-w-0 flex-1 truncate font-mono text-xs text-muted-foreground">
                        {metaLeft}
                    </div>
                    <div className="whitespace-nowrap text-sm font-semibold tabular-nums">
                        {qty}
                    </div>
                </div>
                {thirdLine && (
                    <div className="truncate text-xs text-muted-foreground">
                        {thirdLine}
                    </div>
                )}
            </div>
        </div>
    )
}
